/**
 * The states and union territories of India.
 *
 * A fallback, not the authority. Fields like this are served from the settings
 * module's LOOKUP_SETUP so an institute can curate its own list — but a school
 * that has never opened that screen has no STATE category at all, and a picker
 * with nothing in it is worse than the free-text box it replaced. When the
 * lookup comes back empty, this fills it.
 *
 * Safe to hardcode because, unlike blood groups or designations, this is a
 * national list rather than a per-institute one. It changes when Parliament
 * changes it — last in 2019, when Ladakh was separated from Jammu and Kashmir
 * and the Daman and Diu / Dadra and Nagar Haveli territories were merged.
 */
export const INDIAN_STATES_AND_UTS: readonly string[] = [
    // States
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa',
    'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala',
    'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland',
    'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
    'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
    // Union territories
    'Andaman and Nicobar Islands', 'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir',
    'Ladakh', 'Lakshadweep', 'Puducherry'
];

/**
 * Built-in lists keyed by the catalogue's lookupFieldName, used only when the
 * institute's own lookup for that field is empty.
 */
export const LOOKUP_FALLBACKS: Readonly<Record<string, readonly string[]>> = {
    STATE: INDIAN_STATES_AND_UTS,
    // A name prefix is a fixed set of salutations, not a per-institute list —
    // the same four options Onboard Employee already hardcodes.
    NAME_PREFIX: ['Mr', 'Ms', 'Mrs', 'Dr'],
    // Employment type is catalogued as a Lookup field (EMPLOYEE_DATA_FIELDS), but
    // no screen lets an institute configure its own LOOKUP_SETUP values for it —
    // Onboard Employee's <select> hardcodes these same four. Without this
    // fallback, Bulk Edit's picker came back empty for every school.
    EMPLOYMENT_TYPE: ['PERMANENT', 'CONTRACT', 'VISITING', 'PROBATION']
};
